/* Oculta iconos de pago del pie que no aportan en Mexico.
   Shopify genera esa lista desde los metodos habilitados y no siempre deja
   desactivar marcas de tarjeta individuales desde el admin, asi que se hace
   aqui. Es solo visual: no cambia lo que se acepta en el checkout. */
(function () {
  var HIDE = ['maestro'];

  function labelOf(el) {
    var parts = [];
    var svg = el.querySelector('svg');
    if (svg) {
      if (svg.getAttribute('aria-label')) parts.push(svg.getAttribute('aria-label'));
      var t = svg.querySelector('title');
      if (t) parts.push(t.textContent || '');
      var d = svg.querySelector('desc');
      if (d) parts.push(d.textContent || '');
    }
    var img = el.querySelector('img');
    if (img) {
      if (img.getAttribute('alt')) parts.push(img.getAttribute('alt'));
      if (img.getAttribute('src')) parts.push(img.getAttribute('src'));
    }
    return parts.join(' ').toLowerCase();
  }

  function run() {
    var items = document.querySelectorAll('.list-payment__item, .footer__payment li');
    for (var i = 0; i < items.length; i++) {
      var txt = labelOf(items[i]);
      if (!txt) continue;
      for (var j = 0; j < HIDE.length; j++) {
        if (txt.indexOf(HIDE[j]) !== -1) {
          items[i].style.display = 'none';
          break;
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
